<template lang="pug">
form.form-horizontal
  .form-group
    label.col-sm-2.control-label
      i.icon.mdi.mdi-account(:title="$t('comments.username')")
    .col-sm-6
      p.form-control-static {{ commentName }}
  .form-group
    label.col-sm-2.control-label
      i.icon.mdi.mdi-email(:title="$t('comments.email')")
    .col-sm-6
      p.form-control-static {{ userData.email }}
  .form-group
    label.col-sm-2.control-label
      i.icon.mdi.mdi-help-circle
    .col-sm-9
      textarea.resizable.form-control(rows="6", v-model.trim="commentContents")
  .form-group
    .col-sm-9.col-sm-push-2
      label
        input(style="margin-left: 0px;", type="checkbox", name="private-comment", v-model="commentIsPublic", :disabled="parentIsPrivate")
        span &nbsp;{{ $t('comments.public') }}
  .recaptcha.row
    .col-md-10.col-md-push-2
      vue-recaptcha(ref="recaptcha", :sitekey="recaptchaKey", @verify="onVerify", @expired="onExpired")
  .row
    .col-md-10.col-md-push-2
      button.submit-button.btn.btn-success(type="button", @click.stop="submitComment()") {{ $t('comments.submit') }}
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'commentForm',
  components: {
    vueRecaptcha: VueRecaptcha
  },
  props: {
    comment: {
      type: Object,
      required: false
    },
    reply: {
      type: Object,
      required: false
    },
    contestContentId: {
      type: Number,
      require: true
    },
    contestOrganizerId: {
      type: Number,
      require: true
    },
    isHighlighted: {
      type: Boolean,
      default: false
    },
    isHighlightComment: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      commentContents: '',
      commentRecaptcha: '',
      commentIsPublic: true,
      recaptchaKey: process.env.RECAPTCHA
    }
  },
  computed: {
    commentName () {
      let organizerData = this.userData.organizer.findIndex(a => a.id === this.contestOrganizerId)
      if (organizerData > -1) {
        return this.userData.organizer[organizerData].name
      } else {
        return this.userData.nickname
      }
    },
    parentIsPrivate () {
      if (typeof this.comment !== 'undefined') {
        this.commentIsPublic = !this.comment.isPrivate
        return !!this.comment.isPrivate
      }
      return false
    },
    ...mapGetters({
      getBuilder: 'builder/getBuilder',
      getUserData: 'users/getData'
    })
  },
  methods: {
    resetRecaptcha () {
      try {
        this.$refs.recaptcha.reset()
      } catch (e) {}
    },
    onVerify (response) {
      this.commentRecaptcha = response.trim()
    },
    onExpired () {
      this.resetRecaptcha()
    },
    submitComment () {
      if (this.commentContents === '') {
        this.$swal({
          title: 'Oops!',
          type: 'warning',
          text: this.$t('comments.contentIsEmpty')
        })
        return false
      }
      if (this.commentRecaptcha === '') {
        this.$swal({
          title: 'Oops!',
          type: 'warning',
          text: this.$t('comments.recaptchIsNotChecked')
        })
        return false
      }

      let data = {
        commentRecaptcha: this.commentRecaptcha,
        private: !this.commentIsPublic,
        content: this.commentContents,
        cxid: this.contestContentId,
        parent: 0
      }
      if (typeof this.comment !== 'undefined') {
        data.parent = parseInt(this.comment.ccid, 10)
        if (typeof this.comment.parent !== 'undefined' &&
          parseInt(this.comment.parent, 10) > 0
        ) {
          data.parent = parseInt(this.comment.parent, 10)
        }
      }
      this.submitCompetitionComment(data)
        .then(res => {
          this.commentContents = ''
          this.commentRecaptcha = ''
          this.resetRecaptcha()

          // Amplitude for comments
          let amplitudeClient = window.amplitude.getInstance()
          amplitudeClient.setUserId(this.getUserData.uid)
          amplitudeClient.setUserProperties({
            'Total Comments': res.userTotalComments
          })

          let position = 'Normal'
          if (this.getBuilder.isHighlighted) {
            position = 'Highlight'
          }
          if (this.getBuilder.isHostess) {
            position = 'Hostess'
          }
          amplitudeClient.logEvent('Ask a Question', {
            type: 'Event',
            source: 'Builder',
            Position: position,
            Name: this.getBuilder.title,
            Url: window._env.host.bhuntrContestWebsite + '/' + this.getBuilder.language + '/' + this.getBuilder.alias,
            'Contest ID': this.getBuilder.cid,
            'Private Comment': data.private
          })

          if (typeof this.comment !== 'undefined') {
            this.triggerReplyComment({
              id: this.comment.ccid,
              isHighlightComment: this.isHighlightComment
            })
          }

          if (res.status !== 'published') {
            this.$swal({
              type: 'error',
              title: this.$t('comments.similarCommentNeedReviewingTitle'),
              text: this.$t('comments.similarCommentNeedReviewingContent')
            })
          }

          this.$forceUpdate()
        })
    },
    ...mapActions({
      submitCompetitionComment: 'builder/submitComment'
    })
  },
  mounted () {
    this.$refs.recaptcha.$on('render', id => {
      if (this.$refs.recaptcha.$el.innerHTML === '') {
        console.log('Empty ReCAPTCHA, need to rebuild.')
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.recaptcha {
  margin-bottom: 10px;
}
.control-label {
  padding-top: 0px;
}
.icon {
  font-size: 32px;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/CommentForm.vue